import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { SimpleCodeValue } from "../../core/models/code-value.model";
import { GenericApiResponse } from "../../core/models/api-response.model";

export interface SearchUserRequestVo {
    residentName: string | null | undefined;
    mobileNumber: string | null | undefined;
    areaName: string | null | undefined;
    requestStatus: string[] | null | undefined;
    offset: number;
    limit: number;
}

export interface UserRequestVo {
    userId: number;
    userName: string;
    residentName: string;
    mobileNumber: string;
    emailAddress: string;
    areaName: string;
    location: string;
    requestDate: string; // or Date if you plan to use actual Date objects
    requestStatus: string;
    approvedArea: string;
    approvedBlockNo: string;
    approvedQtrNo: string;
}

export interface LocationAllocation {
    locationId: number;
    allocationId: number;
    residentId: number;
    rank: string;
    residentFirstName: string;
    residentLastName: string;
    locationCode: string;
    locationName: string;
    quarterNumber: string;
    blockNumber: string;
    locationType: string;
}


@Injectable({
    providedIn: 'root'
})
export class UserManagementService {

    constructor(private http: HttpClient) { }

    getUserAreas(): Observable<SimpleCodeValue[]> {
        return this.http.get<SimpleCodeValue[]>('/areas/v1/get-user-areas');
    }

    searchUserRequests(body: SearchUserRequestVo): Observable<UserRequestVo[]> {
        return this.http.post<UserRequestVo[]>('/user-requests/v1/search/user-requests', body);
    }

    updateUserRequest(body: UserRequestVo): Observable<GenericApiResponse> {
        return this.http.post<GenericApiResponse>('/user-requests/v1/user-request', body);
    }

    getUserAllocationsByAreaId(areaId: number): Observable<LocationAllocation[]> {
        return this.http.get<LocationAllocation[]>('/locations/v1/user-allocations/{areaId}'.replace('{areaId}', areaId.toString()));
    }

    approveUserRequest(allocationId: number, userId: number, locationId: number): Observable<GenericApiResponse> {
        return this.http.get<GenericApiResponse>('/user-requests/v1/approve-request/{allocationId}/{userId}/{locationId}'.replace('{allocationId}', allocationId !== null ? allocationId.toString() : '0').replace('{userId}', userId.toString()).replace('{locationId}', locationId.toString()));
    }
}